const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade')) {
          // Bare fix: order from the element's position among its siblings,
          // not the IntersectionObserver callback batch index — the batch
          // index resets to 0 on every callback and desyncs the stagger
          // whenever elements cross the threshold in separate batches.
          const siblings = Array.from(elementTarget.parentElement.children);
          const order = siblings.indexOf(elementTarget);
          // Bare fix: setProperty instead of setAttribute('style', ...),
          // which clobbered any other inline style already on the element.
          elementTarget.style.setProperty('--animation-order', order);
        }
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Bare: the original zoom-in effect used a throttled `scroll` listener that
// wrote a CSS variable on every frame — main-thread work for something the
// compositor can do for free. `animation-timeline: view()` in bare-theme.css
// now drives --zoom-in-ratio directly via CSS on supporting browsers; this
// only handles the reduced-motion bail for browsers where that's unsupported
// (the CSS simply won't apply and the element renders unzoomed, which is a
// fine degradation).
function initializeScrollZoomAnimationTrigger() {
  // Intentionally empty — see comment above. Kept as a named export point
  // in case a future Dawn section still calls it directly.
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
